export const HELP_TEXTS = {
    "start": {
        "title": "Erste Schritte",
        "summary": "Anmelden, die Oberfläche kennenlernen und das eigene Konto einrichten.",
        "steps": [
            "Bei Wirkia anmelden",
            "Passwort vergessen: ein neues festlegen",
            "Die Oberfläche kennenlernen",
            "Alles finden mit der Suche",
            "Mein Konto: Name, E-Mail-Adresse und Passwort ändern",
            "Wirkia auf dem Handy und Tablet nutzen"
        ]
    },
    "start/anmelden": {
        "title": "Bei Wirkia anmelden",
        "summary": "Mit Mandantennummer, E-Mail-Adresse und Passwort melden Sie sich im Backoffice an.",
        "steps": [
            "Öffnen Sie app.wirkia.de im Browser. Auf der Webseite wirkia.de gelangen Sie über die Schaltfläche Login oben rechts dorthin.",
            "Tragen Sie die Mandantennummer ein. Sie ist für alle Mitarbeiter Ihres Unternehmens dieselbe und hat sieben Ziffern.",
            "Geben Sie darunter Ihre E-Mail-Adresse und Ihr Passwort ein und klicken Sie auf Anmelden."
        ]
    },
    "start/passwort-vergessen": {
        "title": "Passwort vergessen: ein neues festlegen",
        "summary": "Über den Link „Passwort vergessen?“ schickt Wirkia Ihnen eine E-Mail, mit der Sie ein neues Passwort festlegen.",
        "steps": [
            "Klicken Sie auf der Anmeldeseite unter dem Passwortfeld auf Passwort vergessen?.",
            "Tragen Sie Mandantennummer und E-Mail-Adresse ein und klicken Sie auf Link anfordern.",
            "Öffnen Sie die E-Mail von Wirkia und klicken Sie auf den Link darin. Er gilt nur kurze Zeit und nur einmal.",
            "Vergeben Sie ein neues Passwort mit mindestens 12 Zeichen, wiederholen Sie es und speichern Sie. Danach melden Sie sich wie gewohnt an."
        ]
    },
    "start/oberflaeche": {
        "title": "Die Oberfläche kennenlernen",
        "summary": "Wo Menü, Suche, Hinweise und Benutzermenü sitzen und wie die Übersicht aufgebaut ist.",
        "steps": [
            "Links steht das Menü. Es ist in Gruppen geordnet, zum Beispiel CRM-Abteilung, Aufträge oder Finanzen. Ein Klick auf den Gruppennamen klappt die Gruppe zu oder auf.",
            "Oben in der Mitte sitzt die Suche. Sie durchsucht Kontakte, Anfragen, Angebote und weitere Bereiche auf einmal.",
            "Rechts oben zeigt die Glocke Hinweise, zum Beispiel neue Anfragen oder überfällige Rechnungen. Daneben öffnet Ihr Name das Benutzermenü.",
            "Die Übersicht zeigt oben Schnellaktionen wie Neue Anfrage und darunter Kennzahlen, Hinweise und Ihren Tag."
        ]
    },
    "start/suche": {
        "title": "Alles finden mit der Suche",
        "summary": "Die Suche oben durchsucht Kontakte, Anfragen, Angebote und mehr. Mit Strg+K springen Sie sofort hinein.",
        "steps": [
            "Klicken Sie oben in das Suchfeld oder drücken Sie Strg+K (am Mac Cmd+K). Auch die Taste / springt ins Feld.",
            "Tippen Sie einen Namen, eine Nummer oder ein Stichwort, zum Beispiel Hartmann. Unter dem Feld erscheinen die Treffer nach Bereichen sortiert.",
            "Wählen Sie einen Treffer mit der Maus oder mit den Pfeiltasten und Enter. Mit Esc schließen Sie die Suche wieder."
        ]
    },
    "start/mein-konto": {
        "title": "Mein Konto: Name, E-Mail-Adresse und Passwort ändern",
        "summary": "Im Benutzermenü unter „Mein Konto“ ändern Sie Ihren Namen, Ihre Anmelde-Adresse und Ihr Passwort und schalten zwischen hellem und dunklem Design um.",
        "steps": [
            "Klicken Sie oben rechts auf Ihren Namen und wählen Sie Mein Konto.",
            "Unter Meine Angaben ändern Sie Ihren Namen. Klicken Sie danach auf Name speichern.",
            "Unter Zugang ändern Sie Ihre E-Mail-Adresse und Ihr Passwort. Beides verlangt zur Sicherheit Ihr aktuelles Passwort.",
            "Im Benutzermenü wechselt das Sonne-/Mond-Symbol zwischen hellem und dunklem Design. Abmelden beendet Ihre Sitzung."
        ]
    },
    "start/handy": {
        "title": "Wirkia auf dem Handy und Tablet nutzen",
        "summary": "Wirkia läuft im Browser jedes Handys und Tablets. Das Menü steckt hinter einem Symbol, Listen zeigen eine Kurzansicht.",
        "steps": [
            "Öffnen Sie app.wirkia.de im Browser Ihres Handys. Eine App aus dem Store brauchen Sie nicht.",
            "Das Menü öffnen Sie über das Symbol oben links. Es schließt sich nach der Auswahl von selbst.",
            "Listen zeigen auf dem Handy je Eintrag eine Kurzansicht mit wenigen Zeilen. Ein Tipp klappt den Eintrag auf."
        ]
    },
    "anfragen": {
        "title": "Anfragen",
        "summary": "Anfragen von Webseite, Telefon und E-Mail sammeln, bearbeiten und beantworten.",
        "steps": [
            "Eine Anfrage bearbeiten und beantworten",
            "Eine Anfrage von Hand erfassen (Telefon, E-Mail, persönlich)",
            "Aus einer Anfrage einen Kontakt anlegen oder zuordnen",
            "Einen Anfragetyp einrichten"
        ]
    },
    "anfragen/anfragen-bearbeiten": {
        "title": "Eine Anfrage bearbeiten und beantworten",
        "summary": "Anfragen von der Webseite, vom Telefon oder per E-Mail landen in einer Liste. Sie öffnen sie, setzen den Status, legen einen Zuständigen fest und halten Notizen fest.",
        "steps": [
            "Öffnen Sie im Menü CRM-Abteilung → Anfragen. Neue Anfragen stehen oben und tragen den Status Neu.",
            "Mit dem Suchfeld finden Sie eine Anfrage über Name, E-Mail, Telefon oder Vorgangsnummer. Filter grenzt nach Status oder Art ein.",
            "Klicken Sie auf eine Anfrage. Oben sehen Sie den Kontakt und darunter das Anliegen mit den Angaben aus dem Formular.",
            "Rechts bei Bearbeitung stellen Sie den Status ein, zum Beispiel In Bearbeitung, sobald Sie sich darum kümmern. Mit Zuständig weisen Sie die Anfrage einem Kollegen zu."
        ]
    },
    "anfragen/anfrage-erfassen": {
        "title": "Eine Anfrage von Hand erfassen (Telefon, E-Mail, persönlich)",
        "summary": "Ruft jemand an oder kommt eine Anfrage per Mail, legen Sie sie selbst an. Sie landet in derselben Liste wie die Anfragen der Webseite.",
        "steps": [
            "Klicken Sie in der Liste der Anfragen auf Neue Anfrage. Auch auf der Übersicht gibt es dieselbe Schaltfläche.",
            "Wählen Sie bei Herkunft, woher die Anfrage kam, und bei Art der Anfrage, worum es geht. Die Art bestimmt, welche weiteren Felder erscheinen.",
            "Tragen Sie unter Kontakt den Namen und die E-Mail-Adresse ein. Beides sind Pflichtfelder (mit * gekennzeichnet), Telefon und Firma sind freiwillig.",
            "Halten Sie das Anliegen fest: die Felder der gewählten Art und die Nachricht oder Notizen zum Gespräch."
        ]
    },
    "anfragen/kontakt-aus-anfrage": {
        "title": "Aus einer Anfrage einen Kontakt anlegen oder zuordnen",
        "summary": "Wirkia erkennt, ob der Absender schon als Kontakt bekannt ist. Sie ordnen ihn zu oder legen ihn mit einem Klick neu an.",
        "steps": [
            "Öffnen Sie die Anfrage. Im Block Kontakt im Kontaktbuch zeigt Wirkia, welche vorhandenen Kontakte zur Anfrage passen, und nennt den Grund, zum Beispiel „gleiche …",
            "Ist es dieselbe Person, klicken Sie auf Zuordnen. Die Anfrage erscheint danach beim Kontakt, und Sie sehen dort alle früheren Vorgänge.",
            "Gibt es keinen passenden Kontakt, klicken Sie oben im Block Kontakt auf + Kontakt anlegen. Wirkia übernimmt Name, E-Mail und Telefon aus der Anfrage."
        ]
    },
    "anfragen/anfragetyp-anlegen": {
        "title": "Einen Anfragetyp einrichten",
        "summary": "Anfragetypen bestimmen, welche Angaben ein Formular auf Ihrer Webseite abfragt, zum Beispiel Fläche, Termin oder Objekt.",
        "steps": [
            "Öffnen Sie über das Zahnrad die Einrichtung und dort Anfragen → Anfragetypen. Die Liste zeigt alle vorhandenen Typen mit Feldern und Sichtbarkeit.",
            "Klicken Sie auf Neuer Anfragetyp und vergeben Sie eine Bezeichnung, zum Beispiel „Baumpflege“. Die Kennung schlägt Wirkia vor, sie lässt sich später nicht mehr ändern.",
            "Legen Sie fest, wer Anfragen dieses Typs sieht. Nicht jeder Mitarbeiter soll jede Anfrage lesen, zum Beispiel keine Bewerbungen oder Freistellungsanträge.",
            "Mit Feld hinzufügen ergänzen Sie die Angaben, die der Kunde machen soll: Text, Zahl mit Einheit, Ja/Nein oder Auswahl."
        ]
    },
    "kontakte": {
        "title": "Kontakte",
        "summary": "Kunden, Firmen und Ansprechpartner pflegen, Dubletten bereinigen.",
        "steps": [
            "Einen Kontakt anlegen",
            "Ansprechpartner einer Firma anlegen",
            "Kontakte finden, filtern und sortieren",
            "Doppelte Kontakte zusammenführen",
            "Beziehungsarten für Kontakte festlegen",
            "Kontakte archivieren oder endgültig löschen"
        ]
    },
    "kontakte/kontakt-anlegen": {
        "title": "Einen Kontakt anlegen",
        "summary": "Kunden, Interessenten, Lieferanten und Partner legen Sie als Person oder Firma an, mit Adresse, Telefon und Beziehungsart.",
        "steps": [
            "Öffnen Sie Stammdaten → Kontakte im Menü und klicken Sie oben auf Neuer Kontakt.",
            "Wählen Sie bei Art, ob es sich um eine Person oder eine Firma handelt, und tragen Sie den Namen ein.",
            "Ergänzen Sie E-Mail, Telefon und die Adresse mit Straße und Hausnummer, Postleitzahl und Ort. Nur Art und Name sind Pflicht.",
            "Wählen Sie die Beziehung: Ist die Person ein Kunde, ein Interessent, ein Lieferant oder ein Partner? Sie dürfen mehrere wählen."
        ]
    },
    "kontakte/ansprechpartner": {
        "title": "Ansprechpartner einer Firma anlegen",
        "summary": "Personen, die bei einer Firma arbeiten, legen Sie als Kontakt mit Verweis auf die Firma an. In der Firma sehen Sie alle Ansprechpartner.",
        "steps": [
            "Legen Sie zuerst die Firma als Kontakt der Art Firma an, falls es sie noch nicht gibt.",
            "Legen Sie dann einen neuen Kontakt der Art Person an. Im Feld Firma wählen Sie die Firma aus der Liste. Die Person ist damit Ansprechpartner dieser Firma.",
            "Öffnen Sie die Firma. Dort stehen die Ansprechpartner mit Telefon und E-Mail untereinander."
        ]
    },
    "kontakte/kontakte-suchen": {
        "title": "Kontakte finden, filtern und sortieren",
        "summary": "Die Kontaktliste durchsuchen Sie über Name, E-Mail, Telefon oder Ort und grenzen sie mit Filtern nach Art und Beziehung ein.",
        "steps": [
            "Tippen Sie in das Suchfeld einen Namen, eine E-Mail-Adresse, eine Telefonnummer oder einen Ort und drücken Sie Enter.",
            "Mit Filter zeigen Sie nur Firmen oder nur Personen oder nur eine bestimmte Beziehung, etwa Lieferanten.",
            "Ein Klick auf eine Spaltenüberschrift wie Name oder Ort sortiert die Liste. Ein zweiter Klick dreht die Reihenfolge um."
        ]
    },
    "kontakte/dubletten": {
        "title": "Doppelte Kontakte zusammenführen",
        "summary": "Ist ein Kunde zweimal angelegt, finden Sie ihn über „Dubletten prüfen“ und führen beide Einträge zu einem zusammen. Anfragen und Aufträge bleiben erhalten.",
        "steps": [
            "Klicken Sie in der Kontaktliste auf Dubletten prüfen. Wirkia sucht Kontakte mit gleicher E-Mail-Adresse, Telefonnummer oder gleichem Namen.",
            "Die Seite Mögliche Dubletten zeigt die gefundenen Paare. Klicken Sie bei einem Paar auf Zusammenführen.",
            "Wirkia stellt beide Kontakte nebeneinander. Wo sie sich unterscheiden, wählen Sie unter Welche Angaben bleiben? die richtige Angabe aus.",
            "Klicken Sie auf Zusammenführen. Der zweite Kontakt verschwindet aus der Liste, seine Anfragen, Aufträge und Ansprechpartner hängen danach am bleibenden Kontakt."
        ]
    },
    "kontakte/beziehungsarten": {
        "title": "Beziehungsarten für Kontakte festlegen",
        "summary": "Beziehungsarten wie Kunde, Interessent oder Lieferant sortieren Ihre Kontakte. Sie legen eigene Arten mit Farbe an.",
        "steps": [
            "Öffnen Sie die Einrichtung (Zahnrad) und dort Kontakte → Beziehungsarten. Die Liste zeigt die vorhandenen Arten und wie viele Kontakte jede hat.",
            "Tragen Sie bei Neue Art einen Namen ein, zum Beispiel „Stammkunde“.",
            "Mit den Pfeilen ordnen Sie die Arten, mit Bearbeiten ändern Sie Namen und Farbe."
        ]
    },
    "kontakte/kontakt-archivieren": {
        "title": "Kontakte archivieren oder endgültig löschen",
        "summary": "Archivieren blendet einen Kontakt aus, er lässt sich zurückholen. Löschen entfernt ihn mit Debitor und Kreditor endgültig aus Wirkia.",
        "steps": [
            "Öffnen Sie Stammdaten → Kontakte und den Kontakt, den Sie ausblenden oder entfernen möchten.",
            "Mit Archivieren verschwindet der Kontakt aus den normalen Listen und der Suche. Er bleibt in der Datenbank.",
            "Mit Endgültig löschen entfernen Sie den Kontakt mit seinem Debitor und Kreditor aus der Datenbank. Wirkia fragt vorher nach. Das lässt sich nicht rückgängig machen."
        ]
    },
    "termine": {
        "title": "Termine und Aufgaben",
        "summary": "Termine und Aufgaben für das Team planen und im Blick behalten.",
        "steps": [
            "Eine Aufgabe anlegen und zuweisen",
            "Einen Termin eintragen",
            "Den Kalender nutzen und freigeben"
        ]
    },
    "termine/aufgabe-anlegen": {
        "title": "Eine Aufgabe anlegen und zuweisen",
        "summary": "Aufgaben halten fest, was zu tun ist, wer es tut und bis wann. Sie legen sie an, weisen sie zu und haken sie ab, sobald sie erledigt sind.",
        "steps": [
            "Öffnen Sie Personalmanagement → Aufgaben. Die Liste zeigt Aufgabe, Fällig, Zuständig und Status. Klicken Sie auf Neue Aufgabe.",
            "Geben Sie einen Titel ein und wählen Sie, wer zuständig ist. Mit Fällig am legen Sie fest, bis wann die Aufgabe erledigt sein soll.",
            "Weitere Mitarbeiter nehmen Sie mit Beteiligte hinzufügen auf. Mit dem Haken In den Kalender übernehmen entsteht zusätzlich ein Termin im Kalender der Zuständigen.",
            "Klicken Sie auf Aufgabe anlegen. Ist die Aufgabe erledigt, klicken Sie in der Liste in ihrer Zeile auf Erledigen."
        ]
    },
    "termine/termin-anlegen": {
        "title": "Einen Termin eintragen",
        "summary": "Termine mit Beginn, Ende und Ort tragen Sie im Kalender ein. Ganztägige Termine wie Betriebsurlaub und Feiertage gehen genauso.",
        "steps": [
            "Öffnen Sie Personalmanagement → Kalender & Termine und klicken Sie auf Neuer Termin.",
            "Tragen Sie den Titel ein und wählen Sie Beginn und Ende. Bei einem Termin über den ganzen Tag setzen Sie den Haken Ganztägig.",
            "Mit Ort geben Sie an, wo der Termin stattfindet. Klicken Sie danach auf Termin anlegen."
        ]
    },
    "termine/kalender-nutzen": {
        "title": "Den Kalender nutzen und freigeben",
        "summary": "Der Kalender zeigt Termine als Tag, Woche oder Monat. Mit „Kalender freigeben“ lassen Sie Kollegen Ihre Termine sehen.",
        "steps": [
            "Mit Tag, Woche und Monat wechseln Sie die Ansicht. Heute springt zum heutigen Tag, die Pfeile blättern vor und zurück.",
            "Ein Klick auf einen Termin öffnet ihn zum Ansehen und Ändern.",
            "Mit Kalender freigeben bestimmen Sie, welche Kollegen Ihre Termine sehen dürfen."
        ]
    },
    "verkauf": {
        "title": "Verkauf",
        "summary": "Von der Produktliste über das Angebot bis zum Auftrag.",
        "steps": [
            "Ein Produkt oder eine Dienstleistung anlegen",
            "Kategorien, Einheiten und Tags für Produkte pflegen",
            "Aus einer Anfrage ein Angebot erstellen",
            "Ein Angebot erstellen",
            "Ein Angebot versenden und nachverfolgen",
            "Aus einer Anfrage direkt einen Auftrag erstellen und disponieren (Chauffeur-Service)",
            "Einen Auftrag bearbeiten",
            "Einen Gutschein ausstellen: verkauft oder verschenkt",
            "Einen Gutschein prüfen, einlösen, sperren und verlängern",
            "Gutscheine in der Buchhaltung: Verbindlichkeiten je Sachkonto",
            "Einen Rabattcode für eine Aktion anlegen"
        ]
    },
    "verkauf/produkt-anlegen": {
        "title": "Ein Produkt oder eine Dienstleistung anlegen",
        "summary": "Waren und Dienstleistungen mit Preis und Steuersatz legen Sie einmal an und übernehmen sie dann in Angebote, Aufträge und Rechnungen.",
        "steps": [
            "Öffnen Sie Stammdaten → Produkte und klicken Sie auf Neues Produkt.",
            "Tragen Sie die Bezeichnung ein und wählen Sie die Art: Ware für Dinge, die Sie verkaufen, Dienstleistung für Arbeitszeit.",
            "Wählen Sie die Einheit (zum Beispiel Stunde oder Stück) und tragen Sie bei Verkaufspreis netto den Preis ohne Umsatzsteuer ein. Darunter stellen Sie den Steuersatz ein.",
            "Wählen Sie bei Buchungsgruppe die Gruppe, die das Sachkonto für den Erlös nennt (siehe „Buchungsgruppen: das Sachkonto je Produkt festlegen“)."
        ]
    },
    "verkauf/produkt-kategorien": {
        "title": "Kategorien, Einheiten und Tags für Produkte pflegen",
        "summary": "In der Einrichtung legen Sie Produktkategorien, eigene Einheiten und Tags an, damit sich das Sortiment sortieren und filtern lässt.",
        "steps": [
            "Öffnen Sie die Einrichtung (Zahnrad) und klappen Sie links die Gruppe Produkte auf. Dort stehen Produktkategorien, Einheiten und Produkt-Tags.",
            "Kategorien ordnen Produkte in Gruppen und Untergruppen, zum Beispiel „Gartenarbeit → Rasen“. Ein Produkt gehört zu einer Kategorie.",
            "Einheiten wie Stunde, Stück oder Quadratmeter erscheinen in Produkten, Angeboten und Rechnungen. Eigene Einheiten legen Sie hier an.",
            "Tags sind frei wählbare Schlagwörter, etwa „Saisonware“. Ein Produkt kann mehrere Tags haben, in der Produktliste filtern Sie danach."
        ]
    },
    "verkauf/angebot-aus-anfrage": {
        "title": "Aus einer Anfrage ein Angebot erstellen",
        "summary": "Aus der Anfrage heraus starten Sie ein Angebot. Der Kunde ist bereits eingetragen, und die Anfrage bleibt mit dem Angebot verknüpft.",
        "steps": [
            "Öffnen Sie die Anfrage und klicken Sie unten rechts bei Bearbeitung auf Angebot erstellen.",
            "Wirkia öffnet den Angebotseditor mit dem Kontakt der Anfrage. Wie es weitergeht, steht unter „Ein Angebot erstellen“.",
            "Alle Angebote zu einer Anfrage stehen später in der Anfrage im Block Angebote, und die Anfrage springt auf den Status Angebot gesendet, sobald Sie das Angebot versenden."
        ]
    },
    "verkauf/angebot-erstellen": {
        "title": "Ein Angebot erstellen",
        "summary": "Im Angebotseditor wählen Sie den Empfänger, schreiben Betreff und Texte und fügen Positionen aus Ihren Produkten hinzu. Wirkia rechnet Rabatte und Umsatzsteuer.",
        "steps": [
            "Öffnen Sie CRM-Abteilung → Angebote und klicken Sie auf Neues Angebot.",
            "Suchen Sie im Feld Empfänger den Kunden: Tippen Sie einen Teil des Namens und wählen Sie ihn aus der Liste.",
            "Passen Sie bei Bedarf die Einleitung an. Wirkia schlägt einen Text vor, der unter „Firmendaten“ einstellbar ist.",
            "Fügen Sie Positionen hinzu: Tippen Sie im Feld Produkt hinzufügen einen Namen, eine Artikelnummer oder eine EAN und wählen Sie das Produkt."
        ]
    },
    "verkauf/angebot-versenden": {
        "title": "Ein Angebot versenden und nachverfolgen",
        "summary": "Ein Angebot versenden Sie per E-Mail mit PDF und einem Link zur Online-Annahme. Sie sehen, ob der Kunde zugesagt hat, und halten Entscheidungen fest.",
        "steps": [
            "Öffnen Sie den Entwurf. Sie können ihn mit Bearbeiten noch ändern und sich mit PDF-Vorschau ansehen, wie er auf Papier aussieht.",
            "Klicken Sie auf Per E-Mail senden. Prüfen Sie Empfänger, Betreff und Text und senden Sie ab.",
            "Verschicken Sie das Angebot auf anderem Weg (Post, Messenger), klicken Sie auf Als manuell versendet abschließen.",
            "Ein versendetes Angebot hat die Stati Versendet, Angenommen oder Abgelehnt. Gibt der Kunde telefonisch Bescheid, tragen Sie es mit Angenommen oder Abgelehnt ein."
        ]
    },
    "verkauf/auftrag-aus-anfrage-disponieren": {
        "title": "Aus einer Anfrage direkt einen Auftrag erstellen und disponieren (Chauffeur-Service)",
        "summary": "Steht der Preis schon in der Anfrage, erstellen Sie daraus mit einem Klick den Auftrag, weisen ihn einem Fahrer und einem Fahrzeug zu und informieren den Kunden per E-Mail.",
        "steps": [
            "Öffnen Sie die Anfrage unter CRM-Abteilung → Anfragen und klicken Sie unten auf Auftrag erstellen.",
            "Enthält die Anfrage einen Preis (zum Beispiel im Feld Preis oder Online-Schätzung), gilt er als Bruttopreis.",
            "Die Anfrage steht danach auf Gewonnen. Zu einer Anfrage gibt es nur einen laufenden Auftrag.",
            "Im Auftrag finden Sie die Karte Disposition. Unter Fahrer stehen alle aktiven Mitarbeiter, die mit Schicht am Tag der Abholung zuerst, mit den Zeiten der Schicht."
        ]
    },
    "verkauf/auftrag-bearbeiten": {
        "title": "Einen Auftrag bearbeiten",
        "summary": "Ein angenommenes Angebot wird zum Auftrag. Dort verfolgen Sie den Stand, geben ihn ans Personalmanagement, legen Aufgaben an, hängen Dateien an und schreiben Rechnungen.",
        "steps": [
            "Öffnen Sie Aufträge → Alle Aufträge. Die Liste zeigt je Auftrag Kunde, Stand, Leistung und Betrag. Ein Klick öffnet den Auftrag.",
            "Mit An Personalmanagement übergeben geben Sie den Auftrag zur Planung frei. Dort wird er auf Mitarbeiter und Fahrzeuge verteilt.",
            "Der Stand wechselt über die Schaltflächen Offen, Geplant, In Arbeit und Erledigt. Stornieren … beendet einen Auftrag, der nicht mehr stattfindet.",
            "Im Block Zugehörige Aufgaben legen Sie mit Neue Aufgabe Arbeitsschritte an, zum Beispiel „Material bestellen“. Sie behalten so im Blick, was zum Auftrag noch zu tun ist."
        ]
    },
    "verkauf/gutschein-ausstellen": {
        "title": "Einen Gutschein ausstellen: verkauft oder verschenkt",
        "summary": "Ein Gutschein ist ein persönliches Guthaben mit eigenem Code. Sie stellen ihn über einen Betrag aus, drucken ihn als PDF und der Inhaber löst ihn ganz oder in Teilbeträgen ein.",
        "steps": [
            "Öffnen Sie CRM-Abteilung → Gutscheine und klicken Sie auf Neuer Gutschein.",
            "Wählen Sie, wie der Gutschein entsteht. Verkauft heißt, der Käufer hat bezahlt: Dann wählen Sie den Gutschein-Artikel, die Zahlungsart (zum Beispiel Überweisung oder …",
            "Tragen Sie den Betrag ein, bis 5.000 €. Die Knöpfe 25, 50, 100 und 200 € füllen das Feld.",
            "Gültig bis ist freiwillig. Ohne Datum gilt der Gutschein bis zum 31.12. des dritten Jahres nach der Ausstellung. Das ist die gesetzliche Verjährung."
        ]
    },
    "verkauf/gutschein-einloesen": {
        "title": "Einen Gutschein prüfen, einlösen, sperren und verlängern",
        "summary": "Mit dem Code sehen Sie das Guthaben und lösen ganz oder in Teilbeträgen ein. Jede Buchung steht im Verlauf des Gutscheins. Ein verlorener Gutschein wird gesperrt.",
        "steps": [
            "Öffnen Sie CRM-Abteilung → Gutscheine. Geben Sie im Feld Code des Gutscheins den Code ein, mit oder ohne Trennstriche, und klicken Sie auf Prüfen.",
            "Wirkia zeigt die Nummer, das Guthaben, die Gültigkeit und den Empfänger. Ist der Gutschein abgelaufen, gesperrt oder aufgebraucht, steht der Grund da.",
            "Tragen Sie bei Betrag einlösen den Betrag ein. Vorgabe ist das ganze Guthaben, ein Teilbetrag ist erlaubt.",
            "Im Verlauf des Gutscheins (Klick auf die Nummer) stehen alle Buchungen mit Datum, Betrag, Guthaben danach und Bearbeiter."
        ]
    },
    "verkauf/gutscheine-buchhaltung": {
        "title": "Gutscheine in der Buchhaltung: Verbindlichkeiten je Sachkonto",
        "summary": "Ein verkaufter Gutschein ist noch kein Umsatz, sondern eine Verbindlichkeit gegenüber dem Inhaber. Der Bericht zeigt sie je Sachkonto und lässt sich für den Steuerberater als CSV laden.",
        "steps": [
            "Verkauf: Der Käufer zahlt. Das ist ein Zahlungseingang ohne Umsatzsteuer und eine Verbindlichkeit gegenüber dem Inhaber, kein Erlös.",
            "Einlösung: Der Inhaber bezahlt eine Leistung mit dem Gutschein. Den Erlös mit Umsatzsteuer zeigt die Rechnung der Leistung, der Gutschein ist dort die Zahlung.",
            "Verfall: Läuft ein Gutschein ab, kann der Inhaber nicht mehr einlösen. Die Verbindlichkeit löst Ihr Steuerberater auf, das ist ein Ertrag ohne Umsatzsteuer.",
            "Verschenkt: Ohne Zahlungseingang wird nichts gebucht. Beim Einlösen mindert der Gutschein die Rechnung, der Betrag ist dann Rabatt oder Werbeaufwand."
        ]
    },
    "verkauf/rabattcode-anlegen": {
        "title": "Einen Rabattcode für eine Aktion anlegen",
        "summary": "Ein Rabattcode ist ein fester Code für alle, zum Beispiel WILLKOMMEN10. Fahrgäste geben ihn in der Fahrgast-App bei der Buchung ein und bekommen den Nachlass.",
        "steps": [
            "Öffnen Sie CRM-Abteilung → Rabattcodes.",
            "Tragen Sie unter Neuer Rabattcode den Code ein, zum Beispiel WILLKOMMEN10.",
            "Bei Gültig ab und Gültig bis begrenzen Sie die Aktion. Höchstzahl Einlösungen begrenzt, wie oft der Code insgesamt gilt, leer heißt unbegrenzt.",
            "Klicken Sie auf Rabattcode anlegen. In der Liste können Sie einen Code sperren und wieder aktivieren."
        ]
    },
    "finanzen": {
        "title": "Rechnungen und Finanzen",
        "summary": "Rechnungen schreiben, Zahlungen verbuchen, Eingangsrechnungen erfassen, Kontenplan und Finanzreport.",
        "steps": [
            "Eine Rechnung schreiben und ausstellen",
            "Einen Zahlungseingang verbuchen",
            "Eine Rechnung stornieren oder eine Gutschrift ausstellen",
            "Zahlungslink auf der Rechnung: Kunden zahlen online per Stripe oder PayPal",
            "Eine Eingangsrechnung erfassen",
            "Den Finanzreport ansehen und exportieren",
            "Den Kontenplan einrichten und pflegen",
            "Finanzeinstellungen: Versteuerung, Zahlungsziel, Bankkonten",
            "QR-Codes auf der Rechnung: PayPal, Stripe und Banküberweisung",
            "Der Kunde bekommt die bezahlte Rechnung per E-Mail",
            "Rechnungsnummern einstellen",
            "Einen Kredit oder Leasingvertrag erfassen und die Raten verfolgen",
            "Ein Finanzierungsvorhaben planen und die Tragfähigkeit prüfen",
            "Die Mappe für Bank oder Leasinggesellschaft erzeugen und das Vorhaben einreichen",
            "Aus einem bewilligten Vorhaben den Vertrag anlegen",
            "Die Kostenstruktur lesen, Personalkosten ergänzen und Arbeitgeberanteile einstellen"
        ]
    },
    "finanzen/rechnung-schreiben": {
        "title": "Eine Rechnung schreiben und ausstellen",
        "summary": "Eine Rechnung legen Sie als Entwurf an, prüfen sie und stellen sie aus. Erst dann bekommt sie ihre Nummer und lässt sich nicht mehr ändern, wie es die GoBD verlangen.",
        "steps": [
            "Öffnen Sie Finanzen → Ausgangsrechnungen und klicken Sie auf Neue Rechnung. Die Liste zeigt bei jeder Rechnung den Stand und den noch Offenen Betrag.",
            "Wählen Sie den Kunden, tragen Sie einen Betreff ein und geben Sie den Zeitraum der Leistung an (Leistung von und Leistung bis).",
            "Fügen Sie die Positionen hinzu, entweder aus Ihren Produkten oder als Freie Position.",
            "Unter Zahlungsbedingungen stellen Sie das Zahlungsziel (in Tagen) und gegebenenfalls Skonto ein. Wirkia nimmt die Werte aus Ihren Einstellungen und dem Kunden vor."
        ]
    },
    "finanzen/zahlung-erfassen": {
        "title": "Einen Zahlungseingang verbuchen",
        "summary": "Geht Geld für eine Rechnung ein, tragen Sie die Zahlung in der Rechnung ein. Wirkia rechnet den offenen Betrag nach und setzt die Rechnung auf bezahlt.",
        "steps": [
            "Öffnen Sie die ausgestellte Rechnung. Im Block Zahlungen klicken Sie auf Zahlung erfassen.",
            "Tragen Sie den Betrag des Geldeingangs, das Datum der Zahlung und die Zahlungsart ein. Bei einer Teilzahlung geben Sie nur den eingegangenen Teil an.",
            "Speichern Sie die Zahlung. Ist der volle Betrag eingegangen, steht die Rechnung auf bezahlt, sonst zeigt sie den offenen Rest.",
            "Eine falsch eingetragene Zahlung nehmen Sie mit Zurücknehmen zurück und tragen sie richtig neu ein. Die Zurücknahme bleibt im Verlauf sichtbar."
        ]
    },
    "finanzen/rechnung-korrigieren": {
        "title": "Eine Rechnung stornieren oder eine Gutschrift ausstellen",
        "summary": "Ausgestellte Rechnungen lassen sich nicht ändern. Fehler korrigieren Sie mit einer Stornorechnung oder einer Gutschrift. Die ursprüngliche Rechnung bleibt dabei erhalten.",
        "steps": [
            "Öffnen Sie die ausgestellte Rechnung. Oben stehen Stornieren … und Gutschrift erstellen ….",
            "Mit Stornieren … heben Sie die ganze Rechnung auf: Wirkia erzeugt eine Stornorechnung mit eigener Nummer und denselben Beträgen mit umgekehrtem Vorzeichen.",
            "Mit Gutschrift erstellen … erstatten Sie nur einen Teil, zum Beispiel einen Rabatt im Nachhinein.",
            "Anschließend schreiben Sie bei Bedarf eine neue, richtige Rechnung. Die Nummernfolge bleibt lückenlos, denn Storno und Gutschrift bekommen jeweils eine eigene Nummer."
        ]
    },
    "finanzen/zahlungslink": {
        "title": "Zahlungslink auf der Rechnung: Kunden zahlen online per Stripe oder PayPal",
        "summary": "Ist Stripe oder PayPal Ihres Unternehmens verbunden, legen Sie zu einer Rechnung einen Zahlungslink an. Der Kunde zahlt online, Wirkia verbucht die Zahlung selbst.",
        "steps": [
            "Öffnen Sie eine ausgestellte Rechnung, die noch offen ist. Sind Zahlungsdienste verbunden, erscheint dort die Karte Online bezahlen.",
            "Klicken Sie auf Link mit Stripe anlegen oder Link mit PayPal anlegen. Der Link verlangt nur den noch offenen Betrag, auch wenn schon eine Teilzahlung eingegangen ist.",
            "Schicken Sie den Link dem Kunden: Mit Kopieren legen Sie ihn in die Zwischenablage, mit Per E-Mail senden verschickt Wirkia ihn an die Adresse des Kunden.",
            "Sobald der Kunde bezahlt hat, erscheint die Zahlung automatisch in der Rechnung, und die Rechnung steht auf bezahlt. Der Kunde bekommt die bezahlte Rechnung per E-Mail."
        ]
    },
    "finanzen/eingangsrechnung-erfassen": {
        "title": "Eine Eingangsrechnung erfassen",
        "summary": "Rechnungen von Lieferanten legen Sie als Beleg ab. Sie können die Datei hochladen, Wirkia liest E-Rechnungen selbst ein. Sie ordnen Sachkonto und Steuerschlüssel zu und halten die Zahlung fest.",
        "steps": [
            "Öffnen Sie Finanzen → Eingangsrechnungen und klicken Sie auf Neue Eingangsrechnung.",
            "Laden Sie den Beleg mit Datei wählen hoch oder ziehen Sie die Datei ins Feld. Am Handy fotografieren Sie ihn mit Foto aufnehmen.",
            "Prüfen oder ergänzen Sie Rechnungsnummer des Lieferanten, Rechnungsdatum und Fällig am.",
            "Unter Beträge geben Sie Netto, Steuerschlüssel und Steuer an. Bei mehreren Steuersätzen auf einer Rechnung fügen Sie mit Weiteren Steuerschlüssel hinzufügen eine Zeile …"
        ]
    },
    "finanzen/finanzreport": {
        "title": "Den Finanzreport ansehen und exportieren",
        "summary": "Der Finanzreport zeigt Erlöse, Aufwand und Umsatzsteuer eines Zeitraums nach Konten. Sie exportieren ihn als CSV für Excel oder als PDF für den Steuerberater.",
        "steps": [
            "Öffnen Sie Finanzen → Finanzreport. Mit den Schaltflächen Dieser Monat, Dieses Quartal oder Dieses Jahr wählen Sie den Zeitraum schnell.",
            "Bei Zuordnung bestimmen Sie, ob eine Rechnung nach Rechnungsdatum (Sollversteuerung) oder nach Zahlungsdatum (Istversteuerung) zählt.",
            "Die Tabellen zeigen Erlöse, Aufwand und Umsatzsteuer je Konto mit Netto, Steuer, Brutto und der Zahl der Belege.",
            "Mit CSV herunterladen (Excel) oder PDF herunterladen nehmen Sie den Report mit, zum Beispiel für Ihren Steuerberater."
        ]
    },
    "finanzen/kontenplan": {
        "title": "Den Kontenplan einrichten und pflegen",
        "summary": "Der Kontenplan ordnet Erlöse und Ausgaben nach Konten. Sie wählen einen Kontenrahmen (Standard, SKR03 oder SKR04) und ergänzen eigene Konten und Kategorien.",
        "steps": [
            "Öffnen Sie Finanzen → Kontenplan. Die Konten stehen in Kategorien, zum Beispiel Vermögen, Verbindlichkeiten oder Umsatzsteuer. Alles aufklappen zeigt alle Konten.",
            "Mit Neues Konto legen Sie ein eigenes Konto an, mit Neue Kategorie eine neue Gruppe. Ein Konto hat eine Nummer, einen Namen und gehört zu einer Kategorie.",
            "Über Kontenrahmen wechseln wählen Sie SKR03 oder SKR04, wenn Ihr Steuerberater damit arbeitet."
        ]
    },
    "finanzen/finanzeinstellungen": {
        "title": "Finanzeinstellungen: Versteuerung, Zahlungsziel, Bankkonten",
        "summary": "In der Einrichtung unter „Finanzen“ legen Sie die Versteuerungsart, den Kontenrahmen, Zahlungsbedingungen und Bankkonten fest.",
        "steps": [
            "Öffnen Sie die Einrichtung (Zahnrad) und links Finanzen → Finanzen.",
            "Bei Versteuerung wählen Sie Sollversteuerung (Umsatzsteuer nach Rechnungsdatum), Istversteuerung (nach Zahlungseingang) oder Kleinunternehmer.",
            "Unter Zahlungsbedingungen tragen Sie ein, nach wie vielen Tagen Rechnungen fällig sind und ob Sie Skonto gewähren.",
            "Unter Rechnungen und Belege stellen Sie unter anderem das Format der E-Rechnung und die Aufbewahrungsdauer ein."
        ]
    },
    "finanzen/qr-codes-rechnung": {
        "title": "QR-Codes auf der Rechnung: PayPal, Stripe und Banküberweisung",
        "summary": "Ist Stripe oder PayPal verbunden, druckt Wirkia beim Ausstellen für jeden Dienst einen QR-Code mit dem Zahlungslink auf die Rechnung. Dazu kommt ein QR-Code für die Banküberweisung.",
        "steps": [
            "Verbinden Sie unter Einrichtung → APIs und Webhooks Stripe oder PayPal (siehe „Stripe und PayPal verbinden“) und tragen Sie unter Einrichtung → Finanzen Ihr Bankkonto …",
            "Stellen Sie eine Rechnung wie gewohnt aus. Beim Ausstellen legt Wirkia für jeden verbundenen Dienst einen Zahlungslink über den offenen Betrag an und druckt ihn als …",
            "Jeder Code trägt einen Titel: PayPal, Stripe oder Banküberweisung. Der Kunde wählt den, der ihm passt.",
            "Zahlt der Kunde über PayPal oder Stripe, verbucht Wirkia die Zahlung selbst, und die Rechnung steht auf bezahlt."
        ]
    },
    "finanzen/bezahlte-rechnung-mail": {
        "title": "Der Kunde bekommt die bezahlte Rechnung per E-Mail",
        "summary": "Nach einer erfolgreichen Online-Zahlung schickt Wirkia dem Kunden die Rechnung mit dem Vermerk „bezahlt“ per E-Mail. Importiert er sie in Wirkia, erkennt das System sie als beglichen.",
        "steps": [
            "Bezahlt ein Kunde über einen Zahlungslink oder den QR-Code per Stripe oder PayPal, verbucht Wirkia die Zahlung in der Rechnung.",
            "Danach geht an die Adresse des Rechnungsempfängers eine E-Mail mit dem Betrag, dem Tag der Zahlung, der Zahlungsart und der Referenz oder Transaktionsnummer.",
            "Die Rechnung im Anhang ist eine Kopie. Das Original in Wirkia bleibt unverändert."
        ]
    },
    "finanzen/rechnungsnummern": {
        "title": "Rechnungsnummern einstellen",
        "summary": "Sie wählen, wie die Rechnungsnummer aufgebaut ist: mit Jahr, mit der Kundennummer oder nur als Nummernserie. Dazu legen Sie fest, bei welcher Nummer Sie beginnen.",
        "steps": [
            "Öffnen Sie Einrichtung → Rechnungsnummern.",
            "Wählen Sie das Schema. Jahr und Nummernserie ergibt zum Beispiel RE-2026-0001, die Serie beginnt mit jedem Jahr neu.",
            "Tragen Sie je Belegart die erste Nummer ein, falls Sie nicht bei 1 beginnen, etwa weil Sie von einem anderen Programm umsteigen.",
            "Die Hinweise unter dem Formular berechnen sich mit jeder Änderung neu: dass ausgestellte Belege unverändert bleiben, dass ein Wechsel des Schemas die Nummern anders …"
        ]
    },
    "finanzen/finanzierung-vertrag-anlegen": {
        "title": "Einen Kredit oder Leasingvertrag erfassen und die Raten verfolgen",
        "summary": "Tragen Sie ein laufendes Darlehen, einen Ratenkauf oder einen Leasingvertrag ein. Wirkia rechnet den Zahlungsplan, zeigt die nächsten Raten und übernimmt die Kosten in Finanzreport und Auswertungen.",
        "steps": [
            "Öffnen Sie Finanzen → Finanzierungen und Leasings und klicken Sie auf Neuer Vertrag.",
            "Wählen Sie die Art: Darlehen, Ratenkauf oder Leasing. Die Felder darunter passen sich an.",
            "Tragen Sie Geldgeber, Laufzeit und den Vertragsbeginn ein, also den Tag der ersten Rate. Gehört der Vertrag zu einem Fahrzeug, wählen Sie es aus der Flotte aus.",
            "Unter dem Formular zeigt Wirkia, was es aus Ihren Angaben rechnet: die Rate, die Zinsen insgesamt und das Ende der Laufzeit."
        ]
    },
    "finanzen/finanzierungsvorhaben-planen": {
        "title": "Ein Finanzierungsvorhaben planen und die Tragfähigkeit prüfen",
        "summary": "Bevor Sie einen Kredit, Ratenkauf oder Leasingvertrag abschließen, legen Sie ihn als Vorhaben an. Wirkia prüft aus Ihren Zahlen, ob die neue Rate getragen wird.",
        "steps": [
            "Öffnen Sie Finanzen → Finanzierungen und Leasings, wechseln Sie auf den Reiter Vorhaben und klicken Sie auf Neues Vorhaben.",
            "Tragen Sie ein, was Sie finanzieren möchten: Art, Bezeichnung, Gegenstand, Wert, Laufzeit und bei Leasing die Rate, sonst den Betrag und den Zinssatz.",
            "Schreiben Sie unter Verwendungszweck und Begründung, wofür Sie das Geld brauchen und warum es sich lohnt. Dieser Absatz steht später in der Mappe an die Bank.",
            "Sobald Sie kurz nicht mehr tippen, zeigt Wirkia unter dem Formular die Tragfähigkeit (Vorschau): den Überschuss vor den Raten, die bestehenden und die neue Rate, was …"
        ]
    },
    "finanzen/finanzierungsmappe-bank": {
        "title": "Die Mappe für Bank oder Leasinggesellschaft erzeugen und das Vorhaben einreichen",
        "summary": "Wirkia erzeugt aus Ihren Zahlen eine PDF-Mappe für die Bank. Sie vermerken, wann Sie das Vorhaben eingereicht haben und wie die Bank entschieden hat.",
        "steps": [
            "Öffnen Sie das Vorhaben und klicken Sie auf Mappe als PDF. Das PDF öffnet sich in einem neuen Tab, dort speichern oder drucken Sie es.",
            "Lesen Sie die Mappe, bevor Sie sie weitergeben. Fehlen Angaben zur Firma wie Handelsregister oder Steuernummer, ergänzen Sie sie unter Einrichtung → Firmendaten und …",
            "Haben Sie die Mappe der Bank gegeben, klicken Sie auf Als eingereicht vermerken.",
            "Meldet sich die Bank, klicken Sie auf Bewilligt oder Abgelehnt und tragen das Datum ein. Im Vermerk können Sie die Konditionen oder den Grund festhalten."
        ]
    },
    "finanzen/vorhaben-vertrag-anlegen": {
        "title": "Aus einem bewilligten Vorhaben den Vertrag anlegen",
        "summary": "Hat die Bank das Vorhaben bewilligt, legt Wirkia daraus mit einem Klick den Vertrag mit Zahlungsplan an. Die Angaben müssen Sie nicht noch einmal eintragen.",
        "steps": [
            "Öffnen Sie ein Vorhaben mit dem Status Bewilligt und klicken Sie auf Vertrag anlegen.",
            "Tragen Sie den Vertragsbeginn laut Vertrag ein, also den Tag der ersten Rate. Prüfen Sie den Geldgeber und ergänzen Sie die Vertragsnummer.",
            "Mit Vertrag anlegen übernimmt Wirkia Art, Beträge, Zinssatz, Rate, Laufzeit, Fahrzeug und Bemerkung aus dem Vorhaben und rechnet den Zahlungsplan.",
            "Im Vorhaben steht jetzt der Vertrag mit seiner Nummer. Weichen die Konditionen im unterschriebenen Vertrag ab, ändern Sie den Vertrag."
        ]
    },
    "finanzen/kostenstruktur-personalkosten": {
        "title": "Die Kostenstruktur lesen, Personalkosten ergänzen und Arbeitgeberanteile einstellen",
        "summary": "Die Kostenstruktur zeigt, was ein Monat kostet und was davon übrig bleibt. Sie ergänzen Personalkosten neben dem Lohn und stellen die Arbeitgeberanteile ein.",
        "steps": [
            "Öffnen Sie Finanzen → Finanzierungen und Leasings und wechseln Sie auf den Reiter Kostenstruktur. Oben stehen die Kacheln mit den Monatswerten.",
            "Lesen Sie die Kacheln von links nach rechts: Einnahmen, veränderliche Kosten, feste Kosten, Personalkosten, der Überschuss vor den Raten und die bestehenden Raten.",
            "Prüfen Sie unter Feste Kosten aus den Eingangsrechnungen, welche Konten Wirkia erkannt hat.",
            "Prüfen Sie unter Personalkosten, ob alle Mitarbeiter erfasst sind."
        ]
    },
    "vertraege": {
        "title": "Verträge",
        "summary": "Verträge erstellen, online unterschreiben lassen, Nachweis prüfen und Verträge kündigen.",
        "steps": [
            "Einen Vertrag erstellen und zur Unterschrift senden",
            "Was Ihr Vertragspartner sieht: online unterschreiben",
            "Nachweis prüfen und den Vertrag in Dokumente ablegen",
            "Einen Vertrag kündigen",
            "Eine Kündigung des Vertragspartners erfassen"
        ]
    },
    "vertraege/vertrag-erstellen": {
        "title": "Einen Vertrag erstellen und zur Unterschrift senden",
        "summary": "Sie schreiben den Vertrag in Wirkia, unterschreiben ihn mit Ihrem Passwort und schicken ihn per E-Mail. Ihr Vertragspartner unterschreibt online, ohne ein Konto zu brauchen.",
        "steps": [
            "Öffnen Sie im Menü Personalmanagement → Verträge und klicken Sie auf Neuer Vertrag.",
            "Wählen Sie eine Vorlage (Dienstleistungsvertrag, Geheimhaltungsvereinbarung, Arbeitsvertrag) oder Leer beginnen, wenn Sie den Text selbst schreiben.",
            "Unter Vertragspartner geben Sie bei Wer unterschreibt? an, ob es ein Mitarbeiter, ein Kontakt oder ein anderer Vertragspartner ist.",
            "Prüfen und ergänzen Sie den Vertragstext. Platzhalter wie der Name des Partners füllt Wirkia beim Speichern aus."
        ]
    },
    "vertraege/vertrag-unterschreiben": {
        "title": "Was Ihr Vertragspartner sieht: online unterschreiben",
        "summary": "Ihr Vertragspartner öffnet den Link aus der E-Mail, liest den Vertrag und unterschreibt mit einem Code, den Wirkia ihm per E-Mail schickt. Er braucht dafür kein Wirkia-Konto.",
        "steps": [
            "Der Vertragspartner öffnet in der E-Mail den Link. Die Seite funktioniert auf dem Handy, am Tablet und am Rechner und verlangt keine Anmeldung.",
            "Unter Online unterschreiben gibt er Ihren vollständigen Namen ein und fordert den Code an. Wirkia schickt ihn an die E-Mail-Adresse, die Sie im Vertrag angegeben haben.",
            "Er trägt den Code aus der E-Mail ein, bestätigt die Erklärung mit einem Haken und unterschreibt.",
            "Möchte er den Vertrag nicht unterschreiben, klickt er auf Vertrag ablehnen und kann einen Grund nennen."
        ]
    },
    "vertraege/vertrag-nachweis": {
        "title": "Nachweis prüfen und den Vertrag in Dokumente ablegen",
        "summary": "Nach der Unterschrift hat der Vertrag ein PDF mit Protokoll, eine Prüfsumme und einen lückenlosen Verlauf. Eine Kopie liegt in Dokumente, beim Unternehmen und beim Vertragspartner.",
        "steps": [
            "Öffnen Sie den Vertrag unter Personalmanagement → Verträge. Bei Unterschriften stehen Name, Zeitpunkt, Art der Bestätigung (Passwort oder Code per E-Mail) und die …",
            "Der Verlauf listet jeden Schritt: Senden, Öffnen, Code angefordert, falscher Code, Unterschrift, Ablehnen, Zurückziehen, Ablauf.",
            "Mit Nachweis prüfen vergleicht Wirkia den Vertragstext, das gespeicherte PDF und den Verlauf mit den Prüfsummen, die beim Unterschreiben festgehalten wurden, und meldet …",
            "Sobald beide unterschrieben haben, legt Wirkia das PDF mit dem Protokoll in Dokumente ab, und zwar zweimal: allgemein beim Unternehmen und bei der Karte des …"
        ]
    },
    "vertraege/vertrag-kuendigen": {
        "title": "Einen Vertrag kündigen",
        "summary": "Wirkia berechnet Kündigungsfrist und Beendigungstermin, erzeugt das Kündigungsschreiben und hält fest, wann es zugegangen ist. Bei Arbeitsverhältnissen gilt die Schriftform.",
        "steps": [
            "Öffnen Sie den unterschriebenen Vertrag und klicken Sie auf Kündigen. Bei Wer kündigt? wählen Sie Wir kündigen.",
            "Wählen Sie die Art der Kündigung: ordentlich (mit Frist) oder außerordentlich, also fristlos.",
            "Wirkia zeigt die berechnete Frist und den Termin, zu dem der Vertrag endet. Möchten Sie einen späteren Termin, tragen Sie ihn unter Anderer Beendigungstermin ein.",
            "Klicken Sie auf Freigeben und bestätigen Sie mit Ihrem Passwort."
        ]
    },
    "vertraege/kuendigung-eingang": {
        "title": "Eine Kündigung des Vertragspartners erfassen",
        "summary": "Kündigt Ihr Mitarbeiter oder Geschäftspartner, tragen Sie den Eingang des Schreibens mit Scan und Termin ein. Wirkia rechnet den Beendigungstermin aus und legt den Nachweis ab.",
        "steps": [
            "Öffnen Sie den Vertrag und klicken Sie auf Kündigen. Bei Wer kündigt? wählen Sie den Vertragspartner.",
            "Speichern Sie die Angaben und öffnen Sie die Kündigung. Dort klicken Sie auf Eingang erfassen und tragen die Art des Zugangs und das Datum ein, an dem das Schreiben bei …",
            "Wirkia berechnet den Termin aus Frist und Eingang. Es gilt der spätere von beiden: Liegt der Termin im Schreiben vor dem Ende der Frist, gilt das Ende der Frist.",
            "Beim Speichern erzeugt Wirkia das Nachweisblatt und legt Scan und Nachweisblatt in Dokumente ab, allgemein und bei der Karte des Vertragspartners."
        ]
    },
    "team": {
        "title": "Mitarbeiter und Schichten",
        "summary": "Mitarbeiterakten, Urlaub, Anträge, Schichtpläne und Löhne.",
        "steps": [
            "Einen Mitarbeiter anlegen",
            "Einem Mitarbeiter einen Zugang zu Wirkia geben",
            "Urlaub oder Freistellung beantragen und genehmigen",
            "Einen Schichtplan erstellen",
            "Die Löhne einrichten: gesetzliche Werte und Einstellungen Ihres Betriebs",
            "Lohn eines Mitarbeiters festlegen: Lohnart, Zahlungsrhythmus und Mindestlohn",
            "Arbeitszeiten erfassen: Stunden, Nacht und Sonntag für den Lohnlauf",
            "Einen Lohnlauf erstellen, prüfen und festschreiben",
            "Löhne überweisen: Überweisungsdatei und Auszahlung",
            "Lohnkosten im Blick: Erinnerungen, Auswertungen und Kennzahlen je Mitarbeiter"
        ]
    },
    "team/mitarbeiter-anlegen": {
        "title": "Einen Mitarbeiter anlegen",
        "summary": "Die Mitarbeiterakte enthält Stammdaten, Anschrift, Urlaubsanspruch und Wochenstunden. Ein Mitarbeiter braucht keinen Zugang zu Wirkia.",
        "steps": [
            "Öffnen Sie Personalmanagement → Mitarbeiter und klicken Sie auf Neuer Mitarbeiter.",
            "Tragen Sie Vorname und Nachname ein. Die Personalnummer können Sie leer lassen, dann vergibt Wirkia die nächste freie Nummer.",
            "Tragen Sie Position, Abteilung und den Eintritt ein. Der Urlaubsanspruch (Tage im Jahr, halbe Tage mit Komma) und die Wochenstunden sind die Grundlage für den Resturlaub …",
            "Unter Kontakt und Anschrift ergänzen Sie private E-Mail, Telefon, Adresse und einen Notfallkontakt. Klicken Sie zum Schluss auf Mitarbeiter anlegen."
        ]
    },
    "team/mitarbeiter-zugang": {
        "title": "Einem Mitarbeiter einen Zugang zu Wirkia geben",
        "summary": "Wer selbst mit Wirkia arbeiten soll, bekommt einen Benutzerzugang. Sie verknüpfen ihn mit der Mitarbeiterakte, damit Urlaub, Schichten und Aufgaben zur Person passen.",
        "steps": [
            "Öffnen Sie die Mitarbeiterakte. Im Block Zugang zu Wirkia sehen Sie, ob der Mitarbeiter schon einen Zugang hat.",
            "Hat er noch keinen, laden Sie ihn über Einrichtung → Benutzer ein (siehe „Einen Benutzer einladen“).",
            "Von da an sieht der Mitarbeiter unter Mein Konto → Ich als Mitarbeiter seine eigenen Daten, seine Schichten und seinen Urlaub und kann Freistellung beantragen."
        ]
    },
    "team/urlaub-beantragen": {
        "title": "Urlaub oder Freistellung beantragen und genehmigen",
        "summary": "Mitarbeiter beantragen Urlaub über „Mein Konto“. Das Büro genehmigt oder lehnt in der Anfrage ab. Genehmigter Urlaub erscheint als ganztägiger Termin im Kalender.",
        "steps": [
            "Der Mitarbeiter öffnet Mein Konto → Ich als Mitarbeiter → Mein Schichtplan und findet dort Freistellung beantragen. Er wählt Art und Zeitraum.",
            "Das Büro findet den Antrag unter CRM-Abteilung → Anfragen. In der Anfrage stehen Zeitraum, Art, Arbeitstage und der Urlaub des Mitarbeiters.",
            "Mit Genehmigen nehmen Sie den Antrag an, mit Ablehnen schreiben Sie eine Begründung, die der Mitarbeiter sieht."
        ]
    },
    "team/schichtplan": {
        "title": "Einen Schichtplan erstellen",
        "summary": "Die Schichtplanung erzeugt aus Wochenstunden und Vorgaben einen Plan als Entwurf, den Sie anpassen und veröffentlichen.",
        "steps": [
            "Öffnen Sie Personalmanagement → Schichtplanung. Mit Ansicht wählen Sie Tag, Woche oder Monat, mit Mitarbeiter zeigen Sie nur eine Person.",
            "Klicken Sie auf + Entwurf erstellen und wählen Sie den Zeitraum. Wirkia verteilt die Wochenstunden der Mitarbeiter auf die Arbeitstage.",
            "Prüfen Sie den Entwurf. Wirkia warnt, wenn Höchstarbeitszeit, Mindestruhezeit oder die Grenze für Urlaubstage je Monat verletzt wird.",
            "Feiertage und Tage, die in der Einrichtung keine Arbeitstage sind, bekommen im Entwurf keine Schicht."
        ]
    },
    "team/loehne-einrichten": {
        "title": "Die Löhne einrichten: gesetzliche Werte und Einstellungen Ihres Betriebs",
        "summary": "In der Einrichtung der Löhne sehen Sie die gesetzlichen Werte, die heute gelten, und tragen Zahlungstag, Zusatzbeitrag der Krankenkasse, Umlagen und das Konto für die Lohnüberweisung ein.",
        "steps": [
            "Öffnen Sie über das Zahnrad die Einrichtung und dort unter Personalmanagement den Bereich Löhne.",
            "Oben stehen die gesetzlichen Werte des laufenden Jahres: Mindestlohn, Minijob-Grenze, Übergangsbereich, Beitragsbemessungsgrenzen und Beitragssätze.",
            "Bei Zahlungsrhythmus der Mitarbeiter wählen Sie, wie oft Löhne üblicherweise ausgezahlt werden.",
            "Unter Beiträge und Steuer tragen Sie den Zusatzbeitrag Ihrer Krankenkasse ein, die Umlagen U1 und U2 (die Sätze nennt Ihre Kasse), einen Richtwert für die …"
        ]
    },
    "team/lohndaten-mitarbeiter": {
        "title": "Lohn eines Mitarbeiters festlegen: Lohnart, Zahlungsrhythmus und Mindestlohn",
        "summary": "In den Lohnstammdaten legen Sie fest, ob ein Mitarbeiter nach Stunden oder mit einem festen Lohn bezahlt wird, wie oft er sein Geld bekommt und welche Steuer- und Versicherungsangaben für die Berechnung gelten.",
        "steps": [
            "Öffnen Sie den Mitarbeiter und dort Lohn und Abrechnung. Klicken Sie bei Vergütung auf Neue Vergütung eintragen.",
            "Wählen Sie die Art der Vergütung: Stundensatz (nach Ist-Zeit) bezahlt die tatsächlich geleisteten Stunden, Festlohn (Pauschalbetrag) ein festes Gehalt je Monat, Woche …",
            "Bei Zuschläge auf den Grundlohn tragen Sie ein, was für Nacht-, Sonntags- und Feiertagsarbeit vereinbart ist.",
            "Unter Lohnstammdaten bearbeiten → Beschäftigung wählen Sie die Beschäftigungsart und den Zahlungsrhythmus. Ohne Angabe gilt die Vorgabe des Betriebs."
        ]
    },
    "team/arbeitszeiten-erfassen": {
        "title": "Arbeitszeiten erfassen: Stunden, Nacht und Sonntag für den Lohnlauf",
        "summary": "Unter Löhne → Arbeitszeiten tragen Sie ein, wann ein Mitarbeiter gearbeitet hat. Der Lohnlauf übernimmt daraus die Stunden und die Zuschläge für Nacht und Sonntag, auch ohne Schichtplanung.",
        "steps": [
            "Öffnen Sie Personalmanagement → Löhne → Arbeitszeiten (oder den Knopf Arbeitszeiten oben in den Löhnen).",
            "Wählen Sie im Formular Arbeitszeit erfassen den Mitarbeiter, das Datum, Beginn, Ende und die Pause in Minuten.",
            "Arbeitet jemand über Mitternacht, tragen Sie das Ende einfach früher als den Beginn ein, zum Beispiel 22:00 bis 06:00.",
            "Klicken Sie auf Erfassen. Über der Liste stehen die Summen je Mitarbeiter im Monat, mit den vertraglichen Wochenstunden als Soll daneben."
        ]
    },
    "team/lohnlauf-erstellen": {
        "title": "Einen Lohnlauf erstellen, prüfen und festschreiben",
        "summary": "Ein Lohnlauf berechnet für einen Tag, eine Woche oder einen Monat den Lohn aller Mitarbeiter: Brutto, Steuern, Sozialversicherung, Auszahlung und Kosten. Mit dem Festschreiben ist er unveränderlich.",
        "steps": [
            "Öffnen Sie Personalmanagement → Löhne. Eine Erinnerung oben führt Sie direkt zum fehlenden Lauf, sonst klicken Sie auf Neuer Lohnlauf.",
            "Wählen Sie die Art (Monat, Woche oder Tag) und den Zeitraum. Der Auszahlungstag kommt aus der Einrichtung.",
            "Wirkia legt einen Entwurf an, mit einer Zeile je Mitarbeiter, der in dem Zeitraum arbeitet, eine Vergütung hat und dessen Zahlungsrhythmus passt.",
            "Klicken Sie bei einem Mitarbeiter auf Eingaben und Berechnung."
        ]
    },
    "team/lohn-ueberweisen": {
        "title": "Löhne überweisen: Überweisungsdatei und Auszahlung",
        "summary": "Aus einem festgeschriebenen Lohnlauf erzeugt Wirkia eine Sammelüberweisung, die Sie im Online-Banking hochladen und freigeben. Wirkia bucht selbst nichts ab.",
        "steps": [
            "Tragen Sie einmal unter Einrichtung → Löhne den Namen und die IBAN Ihres Kontos ein.",
            "Schreiben Sie den Lohnlauf fest. Dann erscheint Überweisungsdatei (SEPA). Ein Klick lädt eine Datei im Format pain.001 mit einer Sammelbuchung mit der Zahlungsart Gehalt.",
            "Melden Sie sich im Online-Banking an und laden Sie die Datei bei Sammelüberweisung oder SEPA-Datei hochladen hoch.",
            "Kommen Sie zurück in Wirkia und klicken Sie im Lohnlauf auf Als ausgezahlt markieren."
        ]
    },
    "team/lohnkosten-auswerten": {
        "title": "Lohnkosten im Blick: Erinnerungen, Auswertungen und Kennzahlen je Mitarbeiter",
        "summary": "Festgeschriebene Löhne zählen als Aufwand im Finanzreport und in den Auswertungen. Wirkia erinnert an fehlende Läufe und zeigt je Mitarbeiter die Lohnkosten und, wo messbar, den Umsatz.",
        "steps": [
            "Auf der Seite Löhne zeigt eine Kachel die Lohnkosten je Monat (geschätzt, mit Arbeitgeberanteilen).",
            "Ein festgeschriebener Lauf erscheint im Finanzreport und bei den Sachposten als zwei Posten: Löhne und Gehälter und Sozialabgaben (Arbeitgeberanteile, Umlagen, …",
            "Die Sachkonten findet Wirkia im Kontenplan über den Namen („Löhne und Gehälter“, „Sozialabgaben“). Fehlen sie, stehen die Posten ohne Konto da.",
            "In der Infobox eines Mitarbeiters zeigt Lohnkosten und Umsatz die Kosten der letzten zwölf Monate."
        ]
    },
    "betrieb": {
        "title": "Fuhrpark, Lager und Dokumente",
        "summary": "Fahrzeuge, Bestände, Inventar und Dateien an einem Ort.",
        "steps": [
            "Ein Fahrzeug anlegen und Fahrten, Kosten und Wartung eintragen",
            "Lagerbestand führen: Wareneingang, Warenausgang, Inventur",
            "Inventar der Betriebsmittel verwalten",
            "Dokumente hochladen und ablegen",
            "Das Auftragsbuch für Mietwagen führen und prüfen"
        ]
    },
    "betrieb/fahrzeug-anlegen": {
        "title": "Ein Fahrzeug anlegen und Fahrten, Kosten und Wartung eintragen",
        "summary": "Jedes Fahrzeug hat eine eigene Akte mit Kennzeichen, Kilometerstand, Fristen, Versicherung, Wartung, Kosten und Fahrtenbuch.",
        "steps": [
            "Öffnen Sie Betrieb → Flotte. Die Liste zeigt Kennzeichen, Fahrer, Kilometer, nächsten Service und die Frist für HU/AU. Klicken Sie auf Neues Fahrzeug.",
            "Tragen Sie Kennzeichen und Bezeichnung ein. Hersteller, Modell, Fahrzeug-Identifizierungsnummer und aktueller Kilometerstand sind freiwillig, aber nützlich.",
            "In der Akte des Fahrzeugs finden Sie die Schaltflächen Fahrt eintragen, Tanken oder Kosten und Wartung eintragen. Damit halten Sie fest, was mit dem Fahrzeug passiert.",
            "Unter Einsätze weisen Sie das Fahrzeug einem Auftrag und einem Fahrer zu (Einsatz planen)."
        ]
    },
    "betrieb/lager-bestand": {
        "title": "Lagerbestand führen: Wareneingang, Warenausgang, Inventur",
        "summary": "Wirkia führt Bestände je Lagerort. Sie buchen Wareneingang, Warenausgang und Umlagerungen und stellen den Bestand bei der Inventur richtig.",
        "steps": [
            "Öffnen Sie Betrieb → Lager. Die Liste zeigt je Artikel den Bestand, den Mindestbestand und den Wert im Einkauf.",
            "Kommt Ware an, klicken Sie auf Wareneingang. Wählen Sie Artikel, Lagerort und Menge. Als Hinweis tragen Sie zum Beispiel die Nummer des Lieferscheins ein.",
            "Verbrauchen oder verkaufen Sie Ware, buchen Sie einen Warenausgang.",
            "Unter Lager → Bewegungen sehen Sie jede Buchung mit Zeit, Art, Artikel, Lagerort und Menge. Eine Fehlbuchung stellen Sie dort richtig."
        ]
    },
    "betrieb/inventar": {
        "title": "Inventar der Betriebsmittel verwalten",
        "summary": "Werkzeuge, Maschinen und Geräte erfassen Sie als Inventar mit Nummer, Standort und Verantwortlichem. Der Anlagenspiegel zeigt die Anschaffungswerte.",
        "steps": [
            "Öffnen Sie Betrieb → Inventar. Die Liste zeigt Nummer, Bezeichnung, Kategorie, Standort, Verantwortlichen und Status. Klicken Sie auf Neues Inventar.",
            "Tragen Sie Bezeichnung, Kategorie, Standort und Verantwortlichen ein, dazu bei Bedarf Anschaffungsdatum und -wert. Speichern Sie den Eintrag.",
            "Wird ein Gerät nicht mehr genutzt, mustern Sie es aus. Es bleibt in der Liste, steht aber nicht mehr im Status „im Einsatz“."
        ]
    },
    "betrieb/dokument-hochladen": {
        "title": "Dokumente hochladen und ablegen",
        "summary": "Verträge, Angebote, Fotos und Schriftverkehr legen Sie zentral ab, ordnen sie einer Art zu und finden sie über die Suche wieder.",
        "steps": [
            "Öffnen Sie Stammdaten → Dokumente. Oben steht der Bereich Dokument hochladen.",
            "Wählen Sie die Art des Dokuments, zum Beispiel Vertrag, Rechnung oder Foto, und schreiben Sie bei Bedarf eine Notiz.",
            "Die Liste zeigt alle Dokumente mit Art, Zuordnung, Größe und Datum. Mit der Suche und dem Filter finden Sie ein Dokument wieder."
        ]
    },
    "betrieb/auftragsbuch": {
        "title": "Das Auftragsbuch für Mietwagen führen und prüfen",
        "summary": "Für Mietwagen mit Fahrer führen Sie ein Auftragsbuch, das sich nicht nachträglich ändern lässt. Aufträge aus Wirkia kommen von selbst hinein, andere tragen Sie von Hand ein.",
        "steps": [
            "Öffnen Sie Aufträge → Auftragsbuch. Oben steht der Stand des Auftragsbuchs: die Letzte Nummer, die Zahl der Einträge im Buch, die Entwürfe und der Hash des letzten …",
            "Aufträge, die Sie in Wirkia anlegen oder aus einem Angebot annehmen, kommen von selbst ins Buch: zuerst der Auftragseingang, dann die Weitergabe an den Fahrer, wenn Sie …",
            "Einen Auftrag, der auf anderem Weg am Betriebssitz eingeht, tragen Sie mit Auftrag von Hand eintragen ein. Er beginnt als Entwurf und lässt sich ändern und löschen.",
            "Mit Ins Auftragsbuch eintragen öffnet sich ein Fenster mit den Angaben."
        ]
    },
    "marketing": {
        "title": "Marketing und Kommunikation",
        "summary": "Newsletter, Beiträge in sozialen Netzwerken, Live Chats und Auswertungen.",
        "steps": [
            "Newsletter-Abonnenten verwalten",
            "Eine Kampagne (Newsletter) schreiben und versenden",
            "Einen Beitrag auf Facebook, LinkedIn und TikTok veröffentlichen",
            "Live Chats beantworten",
            "Das CRM Dashboard: Was heute zu tun ist",
            "Auswertungen lesen: Umsatz, Kunden, Vertrieb, Auslastung"
        ]
    },
    "marketing/newsletter-abonnenten": {
        "title": "Newsletter-Abonnenten verwalten",
        "summary": "Abonnenten nehmen Sie nur mit Einwilligung auf. Wirkia hält fest, wann und wie jemand zugestimmt hat, und lässt ihn sich jederzeit abmelden.",
        "steps": [
            "Öffnen Sie CRM-Abteilung → Abonnenten. Die Liste zeigt Kontakt, Stand, Einwilligung und Herkunft.",
            "Mit Abonnent hinzufügen nehmen Sie einen Kontakt auf, der zugestimmt hat, zum Beispiel mündlich. Tragen Sie die Art der Zustimmung als Notiz ein.",
            "Mit Alle Kontakte aufnehmen übernehmen Sie vorhandene Kontakte auf einmal. Das ist nur zulässig, wenn alle diese Kontakte zugestimmt haben. Prüfen Sie das vorher.",
            "Mit Abmelden in der Zeile tragen Sie ein, dass sich jemand abgemeldet hat, zum Beispiel per Telefon."
        ]
    },
    "marketing/kampagne-senden": {
        "title": "Eine Kampagne (Newsletter) schreiben und versenden",
        "summary": "Sie schreiben eine Nachricht, wählen die Empfänger aus den Abonnenten, schauen die Vorschau an, senden eine Probe an sich selbst und versenden.",
        "steps": [
            "Öffnen Sie CRM-Abteilung → Kampagnen. Die Liste zeigt Stand, Empfänger, Gesendete und Abmeldungen jeder Kampagne. Klicken Sie auf Neue Kampagne.",
            "Geben Sie einen Internen Namen (nur für Sie), einen Betreff und den Text ein. Mit den Platzhaltern {{name}} und {{firma}} spricht Wirkia jeden Empfänger persönlich an.",
            "Unter Empfänger grenzen Sie die Abonnenten ein: nach Art des Kontakts (Kunde, Interessent, …), nach Personen oder Firmen oder nach der Postleitzahl.",
            "Prüfen Sie die Vorschau und klicken Sie auf Test senden: Wirkia schickt die Kampagne nur an Sie selbst."
        ]
    },
    "marketing/beitrag-veroeffentlichen": {
        "title": "Einen Beitrag auf Facebook, LinkedIn und TikTok veröffentlichen",
        "summary": "Ein Beitrag geht aus Wirkia heraus gleichzeitig an alle verbundenen Netzwerke. Facebook und LinkedIn bekommen Text und Link, TikTok ein Video.",
        "steps": [
            "Öffnen Sie CRM-Abteilung → Beiträge. Bei Wohin? wählen Sie die Netzwerke. Nicht verbundene Netzwerke tragen den Zusatz „(noch nicht verbunden)“.",
            "Schreiben Sie den Text (bis 3000 Zeichen). Bei TikTok ist es der Titel des Videos. Bei Facebook und LinkedIn können Sie einen Link anfügen.",
            "Klicken Sie auf Jetzt veröffentlichen. Wirkia zeigt je Netzwerk, ob es geklappt hat."
        ]
    },
    "marketing/live-chat": {
        "title": "Live Chats beantworten",
        "summary": "Besucher Ihrer Webseite schreiben im Chat-Fenster, Sie antworten im Backoffice. Auch Nachrichten über Facebook landen hier.",
        "steps": [
            "Öffnen Sie CRM-Abteilung → Live Chats. Die Reiter Warten auf Antwort, Offen, Meine und Geschlossen sortieren die Unterhaltungen.",
            "Klicken Sie auf eine Unterhaltung und schreiben Sie Ihre Antwort. Der Besucher sieht sie sofort im Chat-Fenster auf der Webseite.",
            "Ist die Frage geklärt, schließen Sie die Unterhaltung. Unter Bewertungen sehen Sie, wie Besucher das Gespräch bewertet haben."
        ]
    },
    "marketing/crm-uebersicht": {
        "title": "Das CRM Dashboard: Was heute zu tun ist",
        "summary": "Das CRM Dashboard zeigt, bei wem Sie heute nachfassen müssen, welche Anfragen neu sind und welche Angebote auf Antwort warten.",
        "steps": [
            "Öffnen Sie CRM-Abteilung → CRM Dashboard. Oben im Block Heute zu tun stehen Heute nachfassen, Neue Anfragen und Angebote warten auf Antwort.",
            "Unter Im Blick sehen Sie zum Beispiel Angebote, die bald ablaufen. Der Trichter zeigt, wie viele Anfragen zu Angeboten und zu Aufträgen geworden sind.",
            "Bei Alle Wiedervorlagen filtern Sie nach Stand (offen, fällig, erledigt) und Bezug. Der Haken Nur meine zeigt nur Ihre eigenen."
        ]
    },
    "marketing/auswertungen": {
        "title": "Auswertungen lesen: Umsatz, Kunden, Vertrieb, Auslastung",
        "summary": "Die Auswertungen zeigen Erlöse, Aufwand und Ergebnis mit Vergleich zum Vorjahr, offene Forderungen und Verbindlichkeiten, die stärksten Kunden und Produkte und den Stand im Vertrieb.",
        "steps": [
            "Öffnen Sie Finanzen → Auswertungen. Oben rechts wählen Sie das Jahr und können mit Exportieren den Finanzreport des Jahres als CSV laden.",
            "Darunter stehen Forderungen und Zahlungsverhalten, die stärksten Kunden, die umsatzstärksten Produkte und die größten Lieferanten.",
            "Der Block Vertrieb zählt Anfragen, Angebote und Aufträge. Arbeitszeit und Fahrzeugeinsatz zeigen die Auslastung Ihres Teams und Ihrer Fahrzeuge."
        ]
    },
    "einrichtung": {
        "title": "Einrichtung",
        "summary": "Firmendaten, Benutzer und Rollen, E-Mail-Postfach, Zahlungsdienste und Abrechnung.",
        "steps": [
            "Buchungsgruppen: das Sachkonto je Produkt festlegen",
            "Firmendaten eintragen",
            "Einen Benutzer einladen",
            "Rollen und Rechte festlegen",
            "E-Mail-Postfach einrichten",
            "Stripe und PayPal verbinden",
            "Facebook, LinkedIn und TikTok verbinden",
            "Das Paket herunterstufen und den Wechsel zurücknehmen",
            "Daten importieren und exportieren",
            "Speicherplatz prüfen und erweitern",
            "Den Chat auf Ihrer Webseite einrichten",
            "Das Anfrageformular Ihrer Webseite anbinden",
            "Die Newsletter-Anmeldung Ihrer Webseite anbinden",
            "Rechnung nach der Fahrt automatisch senden",
            "Alle Daten löschen: das Konto zurücksetzen",
            "Eigene Nummernkennungen festlegen",
            "Festlegen, wohin Ihre Kunden nach der Online-Zahlung kommen",
            "Zusatzbenutzer buchen: Plätze erweitern",
            "Abonnement und Rechnungen von Wirkia ansehen"
        ]
    },
    "einrichtung/buchungsgruppen": {
        "title": "Buchungsgruppen: das Sachkonto je Produkt festlegen",
        "summary": "Jedes Produkt gehört zu einer Buchungsgruppe. Die Gruppe nennt das Sachkonto, auf das der Erlös gebucht wird, wenn das Produkt auf einer Rechnung steht. Das Konto legt Ihr Steuerberater fest.",
        "steps": [
            "Öffnen Sie die Einrichtung und dort Produkte → Buchungsgruppen.",
            "Legen Sie eine Gruppe an. Tragen Sie den Namen ein, zum Beispiel „Fahrten 19 %“, wählen Sie die Art und tragen Sie das Sachkonto ein, das Ihr Steuerberater nennt.",
            "Öffnen Sie ein Produkt (Stammdaten → Produkte) und wählen Sie im Feld Buchungsgruppe die passende Gruppe. Speichern Sie.",
            "Für Gutscheine legen Sie ein Produkt „Geschenkgutschein“ an, ordnen ihm die Gruppe der Art Gutschein zu und wählen es beim Ausstellen eines verkauften Gutscheins als …"
        ]
    },
    "einrichtung/firmendaten": {
        "title": "Firmendaten eintragen",
        "summary": "Anschrift, Steuerangaben, Bankverbindung und Logo stehen auf jedem Angebot und jeder Rechnung. Tragen Sie sie einmal vollständig ein.",
        "steps": [
            "Öffnen Sie das Zahnrad (Einrichtung) und dort Allgemein → Firmendaten.",
            "Laden Sie bei Logo Ihr Firmenlogo hoch und tragen Sie Firmenname, Straße, PLZ, Ort, Telefon, E-Mail und Webseite ein.",
            "Unter Rechtliche Angaben stehen Geschäftsführung, Registergericht, Registernummer, Steuernummer und USt-IdNr.",
            "Unter Bankverbindung tragen Sie Bank, IBAN und BIC ein. Sie erscheinen auf Angeboten und Rechnungen."
        ]
    },
    "einrichtung/benutzer-einladen": {
        "title": "Einen Benutzer einladen",
        "summary": "Mitarbeiter bekommen einen eigenen Zugang. Sie laden sie per E-Mail oder Link ein und legen mit der Rolle fest, was sie sehen und tun dürfen.",
        "steps": [
            "Öffnen Sie die Einrichtung und dort Allgemein → Benutzer. Die Liste zeigt Rolle, Status und letzte Anmeldung. Klicken Sie auf Benutzer einladen.",
            "Tragen Sie Name und E-Mail ein und wählen Sie die Rolle: zum Beispiel Büro, Mitarbeiter oder Inhaber. Die Rolle bestimmt die Rechte.",
            "Mit dem Haken Einladung zusätzlich per E-Mail … schickt Wirkia dem Benutzer den Link per Mail. Klicken Sie auf Einladung erstellen.",
            "Wirkia zeigt den Einladungslink. Schicken Sie ihn dem Benutzer, falls Sie ihn nicht per Mail verschickt haben. Über den Link vergibt der Benutzer sein eigenes Passwort."
        ]
    },
    "einrichtung/rollen-rechte": {
        "title": "Rollen und Rechte festlegen",
        "summary": "Rollen bündeln Rechte. Sie bestimmen, welche Bereiche ein Benutzer sehen, ändern oder löschen darf.",
        "steps": [
            "Öffnen Sie die Einrichtung und dort Allgemein → Rollen & Rechte. Wirkia bringt vier Rollen mit: Inhaber, Büro, Mitarbeiter und Technischer Manager.",
            "Mit Neue Rolle legen Sie eine eigene Rolle an, zum Beispiel „Buchhaltung“.",
            "Bei einigen Bereichen gibt es Zusatzrechte, etwa Rechnungen ausstellen und versenden oder Lohn- und Abrechnungsdaten ansehen. Sie setzen das Ansehen des Bereichs voraus.",
            "Danach weisen Sie die Rolle einem Benutzer zu (Einrichtung → Benutzer → Bearbeiten). Die Rechte gelten sofort bei der nächsten Seite, die der Benutzer öffnet."
        ]
    },
    "einrichtung/email-einrichten": {
        "title": "E-Mail-Postfach einrichten",
        "summary": "Damit Wirkia Angebote, Kampagnen und Bestätigungen in Ihrem Namen versendet, hinterlegen Sie Ihr eigenes Postfach. Das gehört zur Einrichtung jedes Unternehmens.",
        "steps": [
            "Öffnen Sie die Einrichtung und dort Schnittstellen → APIs und Webhooks. Bei E-Mail-Versand klicken Sie auf Einrichten.",
            "Wählen Sie bei Anbieter Ihren Mail-Anbieter. Wirkia füllt SMTP-Server, Port und Verschlüsselung aus.",
            "Tragen Sie Benutzername (meist die volle E-Mail-Adresse) und Passwort ein.",
            "Unter Absender tragen Sie Name des Absenders und Absenderadresse ein. Die Adresse muss zu Ihrem Postfach gehören. Die meisten Anbieter lehnen fremde Absender ab."
        ]
    },
    "einrichtung/zahlungsdienste-verbinden": {
        "title": "Stripe und PayPal verbinden",
        "summary": "Mit Ihrem eigenen Stripe- oder PayPal-Konto bieten Sie auf Rechnungen einen Zahlungslink an. Das Geld geht direkt an Sie. Die Einrichtung läuft in zwei Schritten.",
        "steps": [
            "Öffnen Sie Einrichtung → Schnittstellen → APIs und Webhooks und wählen Sie bei Stripe oder PayPal Einrichten.",
            "Stripe, Schritt 1: Legen Sie im Stripe-Dashboard unter Entwickler → API-Schlüssel einen eingeschränkten Schlüssel an.",
            "Stripe, Schritt 2: Wirkia zeigt nach dem Speichern eine Webhook-Adresse.",
            "PayPal, Schritt 1: Legen Sie im PayPal Developer Dashboard (developer.paypal.com) unter Apps und Anmeldedaten eine App an."
        ]
    },
    "einrichtung/soziale-netzwerke-verbinden": {
        "title": "Facebook, LinkedIn und TikTok verbinden",
        "summary": "Sie melden sich bei dem Netzwerk an und erlauben Wirkia den Zugriff auf Ihre Seite. Danach veröffentlichen Sie Beiträge aus Wirkia, bei Facebook auch Anfragen und Nachrichten.",
        "steps": [
            "Öffnen Sie Einrichtung → Schnittstellen → APIs und Webhooks und klicken Sie beim Netzwerk auf Einrichten.",
            "Klicken Sie auf Mit Facebook verbinden (bei LinkedIn und TikTok entsprechend). Wirkia leitet Sie zum Netzwerk weiter.",
            "Zurück in Wirkia wählen Sie bei Facebook die Seite und bei LinkedIn die Unternehmensseite, über die Wirkia arbeiten soll.",
            "Mit Trennen beenden Sie die Verbindung. Wirkia löscht die gespeicherten Zugangsdaten und kann danach nicht mehr in Ihrem Namen veröffentlichen."
        ]
    },
    "einrichtung/paket-herunterstufen": {
        "title": "Das Paket herunterstufen und den Wechsel zurücknehmen",
        "summary": "Sie stufen Ihr Paket im Backoffice selbst herunter. Wirkia erklärt vorher alle Folgen, der Wechsel gilt ab dem nächsten Abrechnungszeitraum, und bis dahin lässt er sich zurücknehmen.",
        "steps": [
            "Öffnen Sie die Einrichtung (Zahnrad) und dort Allgemein → Wirkia Konto. Unter Die Pakete steht bei jedem kleineren Paket die Schaltfläche Herunterstufen.",
            "Klicken Sie auf Herunterstufen. Ein Fenster zeigt Ihnen ausführlich: ab wann der Wechsel gilt, was das Paket dann kostet, welche Bereiche und Verbindungen wegfallen und …",
            "Lesen Sie unter Diese Daten werden unwiderruflich gelöscht genau nach. Dort steht, wie viele Angebote, Produkte, Aufträge und andere Einträge verschwinden.",
            "Sichern Sie Ihre Daten vorher über Import und Export. Setzen Sie dann den Haken bei Ich habe die Folgen gelesen … und klicken Sie auf Verbindlich herunterstufen."
        ]
    },
    "einrichtung/import-export": {
        "title": "Daten importieren und exportieren",
        "summary": "Kontakte und Produkte übernehmen Sie aus einer Tabelle (zum Beispiel Excel). Alle Ihre Daten exportieren Sie als CSV oder ZIP für den Steuerberater oder zur Sicherung.",
        "steps": [
            "Öffnen Sie Finanzen → Import und Export (unter System). Dort stehen zwei Karten: Import und Export.",
            "Beim Import wählen Sie, ob Sie Kontakte oder Produkte übernehmen.",
            "Wirkia zeigt vorab eine Vorschau und nennt Zeilen mit Problemen. Angelegt wird erst, wenn Sie bestätigen. So landet nichts Falsches in Ihren Daten.",
            "Beim Export wählen Sie einzelne Bereiche als CSV oder alles als ZIP, auf Wunsch mit den Dokumenten. Das eignet sich für den Steuerberater oder als Sicherung."
        ]
    },
    "einrichtung/speicher": {
        "title": "Speicherplatz prüfen und erweitern",
        "summary": "Unter „Speicherverwaltung“ sehen Sie, wie viel Platz Dateien und Fotos belegen, löschen Altes und buchen bei Bedarf Zusatzspeicher.",
        "steps": [
            "Öffnen Sie die Einrichtung und dort Allgemein → Speicherverwaltung. Der Block Speicherverbrauch zeigt, wie viel Platz belegt ist.",
            "Unter Alle Dateien verwalten sehen Sie jede Datei mit Bereich, Größe und Datum. Haken Sie nicht mehr benötigte Dateien an und klicken Sie auf Ausgewählte löschen.",
            "Brauchen Sie mehr Platz, wählen Sie unter Zusatzspeicher buchen ein Paket und klicken Sie auf Buchen."
        ]
    },
    "einrichtung/chat-fuer-webseite": {
        "title": "Den Chat auf Ihrer Webseite einrichten",
        "summary": "Sie legen in Wirkia einen Schlüssel an, stellen das Chat-Fenster ein und fügen eine Zeile Code oder das WordPress-Plugin in Ihre Webseite ein. Titel, Farbe und Supportzeiten ändern Sie danach nur noch in Wirkia.",
        "steps": [
            "Öffnen Sie Einrichtung → APIs und Webhooks → Chat (Webseite). Unter 1.",
            "Kopieren Sie den Schlüssel sofort. Wirkia zeigt ihn nur dieses eine Mal ganz an, danach nur noch seinen Anfang.",
            "Unter 2. Chat-Fenster stellen Sie ein, was Ihre Besucher sehen: den Titel, die Farbe, die Begrüßung, die Adresse Ihrer Datenschutzerklärung, die Supportzeiten …",
            "Unter 3. Code oder Plugin laden Sie das WordPress-Plugin oder das Paket für jede andere Webseite herunter. Beide enthalten dasselbe Chat-Fenster."
        ]
    },
    "einrichtung/webseite-formulare": {
        "title": "Das Anfrageformular Ihrer Webseite anbinden",
        "summary": "Sie legen in Wirkia selbst den Schlüssel für Ihr Anfrageformular an, tragen ihn in die Einstellungen Ihrer Webseite ein und senden die Anfragen mit den Feldern Ihres Anfragetyps an Wirkia.",
        "steps": [
            "Öffnen Sie Einrichtung → APIs und Webhooks → Anfragen (Webseite). Unter 1.",
            "Der Schlüssel ist zunächst verborgen. Mit Anzeigen blenden Sie ihn ein, mit Verbergen wieder aus, Kopieren legt ihn in die Zwischenablage.",
            "Unter 2. Einstellungen für Ihre Webseite stehen fertig die zwei Zeilen für die Datei .env Ihrer Webseite: die Adresse der Wirkia-Schnittstelle (`WIRKIA_API_URL`) und Ihr …",
            "Unter 3. Anfragetypen und Felder sehen Sie jeden Anfragetyp mit den Schlüsseln seiner Felder, zum Beispiel `fromAddress` für die Abholadresse."
        ]
    },
    "einrichtung/newsletter-anmeldung-webseite": {
        "title": "Die Newsletter-Anmeldung Ihrer Webseite anbinden",
        "summary": "Sie legen in Wirkia selbst den Schlüssel für das Anmeldeformular Ihres Newsletters an. Die Webseite sendet Name, E-Mail-Adresse und Einwilligung an Wirkia, die Person bekommt eine Bestätigungsmail.",
        "steps": [
            "Öffnen Sie Einrichtung → APIs und Webhooks und dort die Kachel Newsletter (Webseite). Unter 1.",
            "Blenden Sie den Schlüssel mit Anzeigen ein und kopieren Sie ihn. Unter 2.",
            "Das Formular sendet mit `POST` an `…/marketing/subscribe`, mit dem Schlüssel im Kopf `Authorization: Bearer …`: Name, E-Mail-Adresse, `consent: true` und im Feld …",
            "Prüfen Sie das Ergebnis unter Marketing → Abonnenten. Die Person steht dort als ausstehend, bis sie die Bestätigungsmail beantwortet hat."
        ]
    },
    "einrichtung/rechnung-nach-der-fahrt": {
        "title": "Rechnung nach der Fahrt automatisch senden",
        "summary": "Schließt der Fahrer eine Fahrt ab, erstellt Wirkia die Rechnung, stellt sie aus und schickt sie dem Kunden. Sie schalten die Automatik ein oder aus und passen den Mailtext an.",
        "steps": [
            "Öffnen Sie Einrichtung → Rechnung nach der Fahrt.",
            "Mit dem Häkchen Rechnung nach Abschluss der Fahrt automatisch erstellen und an den Kunden senden schalten Sie die Automatik ein oder aus.",
            "Unter Text der Mail an den Kunden ändern Sie Betreff und Text.",
            "Klicken Sie auf Speichern."
        ]
    },
    "einrichtung/daten-loeschen": {
        "title": "Alle Daten löschen: das Konto zurücksetzen",
        "summary": "Der Inhaber kann jederzeit alle Daten des Unternehmens endgültig löschen. Das Konto steht danach wieder so da wie am Anfang, Paket und Zugang bleiben.",
        "steps": [
            "Öffnen Sie Einrichtung → Daten löschen. Die Seite listet, was gelöscht wird (Kontakte, Anfragen, Angebote, Aufträge, Produkte, Termine, Aufgaben, ausgestellte …",
            "Lesen Sie den Hinweis zu den Aufbewahrungsfristen. Rechnungen, Buchungsbelege und das Auftragsbuch müssen Sie gesetzlich mehrere Jahre aufbewahren, zum Beispiel …",
            "Geben Sie unter Konto zurücksetzen Ihr Passwort ein und tippen Sie zur Bestätigung ALLES LÖSCHEN ein. Klicken Sie auf Alle Daten endgültig löschen."
        ]
    },
    "einrichtung/nummernkennungen": {
        "title": "Eigene Nummernkennungen festlegen",
        "summary": "Sie bestimmen, womit die Nummern in Ihrem Unternehmen beginnen, zum Beispiel UNIQ statt RE bei Rechnungen. Das gilt für alles, was eine laufende Nummer bekommt.",
        "steps": [
            "Öffnen Sie Einrichtung → Nummernkennungen. Sie sehen alle Nummernkreise: Rechnungen, Gutschriften, Stornorechnungen, Angebote, Aufträge, Anfragen, Verträge, Kündigungen, …",
            "Tragen Sie bei dem Nummernkreis die gewünschte Kennung ein. Unter dem Feld zeigt Wirkia ein Beispiel, wie die nächste Nummer aussieht.",
            "Klicken Sie auf Speichern. Mit Alle auf Standard setzen kehren Sie zu den Kennungen von Wirkia zurück (zum Beispiel RE für Rechnungen)."
        ]
    },
    "einrichtung/seite-nach-zahlung": {
        "title": "Festlegen, wohin Ihre Kunden nach der Online-Zahlung kommen",
        "summary": "Nach einer Zahlung per Stripe oder PayPal sieht Ihr Kunde standardmäßig eine Dankeseite von Wirkia. Sie können stattdessen eine Seite Ihrer eigenen Webseite angeben.",
        "steps": [
            "Öffnen Sie Einrichtung → APIs und Webhooks und dort Stripe oder PayPal. Bei beiden gibt es die Karte Nach der Zahlung.",
            "Tragen Sie bei Seite nach erfolgreicher Zahlung die Adresse ein, zum Beispiel https://www.beispiel.de/danke.",
            "Speichern Sie. Leer gelassen führt der Kunde auf die Seite von Wirkia. Mit Zurücksetzen kehren Sie dazu zurück."
        ]
    },
    "einrichtung/zusatzbenutzer": {
        "title": "Zusatzbenutzer buchen: Plätze erweitern",
        "summary": "In jedem Paket ist ein Benutzer enthalten. Weitere Benutzer buchen Sie als Zusatzbenutzer für 5 € brutto im Monat, jeweils einzeln kündbar.",
        "steps": [
            "Öffnen Sie Einrichtung → Benutzer und klicken Sie oben auf Benutzerlizenzen kaufen. Ein Fenster mit drei Schritten öffnet sich.",
            "Schritt 1, Anzahl: Tragen Sie ein, wie viele Zusatzbenutzer Sie brauchen. Wirkia rechnet darunter aus, was das im Monat kostet (Anzahl × 5 € brutto).",
            "Schritt 2, Kosten: Das Fenster zeigt, was die erste Rechnung anteilig bis zum Ende des laufenden Zyklus Ihres Pakets kostet, wie es danach weiterläuft und wie Sie …",
            "Schritt 3, Bestätigen: Setzen Sie den Haken und klicken Sie auf Zahlungspflichtig buchen. Die Plätze stehen sofort zur Verfügung, die erste Rechnung kommt per E-Mail."
        ]
    },
    "einrichtung/abonnement-rechnungen": {
        "title": "Abonnement und Rechnungen von Wirkia ansehen",
        "summary": "Unter „Wirkia Konto“ sehen Sie Ihr Paket, die Zahlungsart, bis wann abgerechnet ist und alle Rechnungen von Wirkia mit ihrem Stand, vom Beleg bis zur Zahlung.",
        "steps": [
            "Öffnen Sie Einrichtung → Wirkia Konto und blättern Sie nach unten bis Ihr Paket.",
            "Unter Ihr Paket sehen Sie das gebuchte Paket, die Zahlungsart, bis wann abgerechnet ist und, falls Sie gekündigt oder ein Herunterstufen vorgemerkt haben, Gekündigt zum …",
            "Die Tabelle Zahlungen und Rechnungen listet jeden Abrechnungszeitraum mit Leistung, Betrag, Fälligkeit und dem Stand. Von dort laden Sie die Rechnung herunter."
        ]
    }
};
//# sourceMappingURL=help-texts.js.map